/**
 * Page Banner: styles + background video (YouTube, Vimeo, HTML5).
 */
import './style.scss';

document.addEventListener('DOMContentLoaded', initPageBannerVideos);

function initPageBannerVideos() {
	document
		.querySelectorAll('.page-banner__video[data-type]')
		.forEach((el) => {
			const type = el.getAttribute('data-type');
			const id = el.getAttribute('data-id');
			if (type === 'youtube' && id) initYouTube(el, id);
			else if (type === 'vimeo' && id) initVimeo(el, id);
			else if (type === 'html5') initHtml5(el);
		});
}

function initYouTube(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		autoplay: '1',
		mute: '1',
		loop: '1',
		playlist: videoId,
		controls: '0',
		rel: '0',
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://www.youtube.com/embed/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute(
		'allow',
		'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
	);
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'page-banner__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initVimeo(container, videoId) {
	container.style.opacity = '0';
	const params = new URLSearchParams({
		background: 1,
		autoplay: 1,
		muted: 1,
		loop: 1,
	});
	const iframe = document.createElement('iframe');
	iframe.src = `https://player.vimeo.com/video/${videoId}?${params}`;
	iframe.setAttribute('frameborder', '0');
	iframe.setAttribute('allow', 'autoplay; fullscreen');
	iframe.setAttribute('allowfullscreen', '');
	iframe.className = 'page-banner__video-iframe';
	iframe.onload = () => {
		container.style.opacity = '1';
	};
	container.appendChild(iframe);
	setTimeout(() => {
		container.style.opacity = '1';
	}, 2000);
}

function initHtml5(container) {
	container.style.opacity = '0';
	const mp4 = container.getAttribute('data-mp4');
	const webm = container.getAttribute('data-webm');
	const poster = container.getAttribute('data-poster');
	const video = document.createElement('video');
	video.setAttribute('playsinline', '');
	video.setAttribute('muted', '');
	video.setAttribute('autoplay', '');
	video.setAttribute('loop', '');
	if (poster) video.setAttribute('poster', poster);
	video.className = 'page-banner__video-html5';
	if (webm) {
		const s = document.createElement('source');
		s.src = webm;
		s.type = 'video/webm';
		video.appendChild(s);
	}
	if (mp4) {
		const s = document.createElement('source');
		s.src = mp4;
		s.type = 'video/mp4';
		video.appendChild(s);
	}
	video.addEventListener(
		'canplay',
		() => {
			container.style.opacity = '1';
		},
		{ once: true }
	);
	container.appendChild(video);
	video.play().catch(() => {});
}
